import React, {useCallback, useEffect, useState} from "react";
import classNames from 'classnames';
import { SearchBar } from "./searchBar.js";
import { Facets } from "./filter.js";
import { Pagination } from "./pagination.js";
import {useSearchParams} from "react-router-dom";
import ReactDOM from "react-dom/client";
import Saved from "../saved/saved";

function Search( { el, api } ) {
  const [ data, setData ] = useState([]);
  const [ meta, setMeta ] = useState([]);
  const [ queryString, setQueryString ] = useState( window.location.search );
  const [ searchParams, setSearchParams ] = useSearchParams();
  const [ page, setPage ] = useState(searchParams.get('_page'));
  const [ keyword, setKeyword ] = useState(searchParams.get('keywords') ?? '');
  const [ initalFacets, setInitalFacets ] = useState(false);
  const [ dataState, setDatastate ] = useState(false);
  const [ facets, setFacets ] = useState([]);
  const [ dataUpdated, setDataUpdated ] = useState(false);

  // get search keyword from child component (searchBar.js)
	const handleKeyword = (arg) => {
		setKeyword(arg);

    setPage(1);
	};
	// get facets from child component (filter.js)
	const handleFacetData = (arg) => {
		setFacets(arg);

    setPage(1);
  };
	// get pagination from child component (pagination.js)
	const updatePage = (arg) => {
		setPage(arg);
	};

// Update query params on facet, page, keyword change.
  useEffect(() => {
    // Facets
    for (let arg in facets) {
      if (facets[arg].length) {
        if (typeof facets[arg] === 'string' || facets[arg] instanceof String) {
          searchParams.set(arg, facets[arg]);
        }
        else {
          searchParams.set(arg, facets[arg].join(','));
        }
      }
      else {
        searchParams.delete(arg);
      }
    }

    // Page
    searchParams.set('_page', page ?? 1);

    // Keyword
    if (keyword.length > 0) {
      searchParams.set('keywords', keyword);
    }
    else {
      searchParams.delete('keywords');
    }

    setSearchParams(`?${new URLSearchParams(searchParams)}`);
    setQueryString(new URLSearchParams(searchParams));
    window.history.pushState( {}, '', `${window.location.pathname}?${new URLSearchParams(searchParams)}` );

  }, [facets, page, keyword]);

  useEffect( () => {
    const fetchData = async () => {
      let url = api + window.location.search;
      const data = await fetch(url);
      // convert data to json
      const json = await data.json();

      // set state with the result
      await setData(json.results);
      await setMeta(json.meta);

      // Changes from FALSE to array when set, should only change on the inital load.
      if (!initalFacets) {
        await getInitalFacets(json.meta);
        await getSearchResults(json.results);
      }
    }

    fetchData().catch( fault => {
      console.log(fault);
    });

  },[ queryString ]);

  const getInitalFacets = useCallback(  async (_meta) => {
    let _facetData = [];
    let _facets = _meta.facets ?? [];
    _facets.forEach((value, key) => {
      let id = value.name;
      _facetData[id] = searchParams.get(id) ? searchParams.get(id).split(',') : [];
    });

    await setInitalFacets(_facetData);
  }, []);

  const getSearchResults = useCallback(  async (_data) => {
    let _results = _data ?? [];
    await setDatastate(_results.length > 0);
  }, [ data ]);

  useEffect( () => {
    const domEls = el.querySelectorAll('.card__toggle-save');
    if (domEls.length) {
      domEls.forEach(el => {
        let root = ReactDOM.createRoot(el);
        root.render(<Saved api={el.dataset.api} user={el.dataset.user} hasSaved={el.dataset.saved} title={el.dataset.title} />);
      });
    }
  }, [ dataUpdated ]);

	return (
		<div className = "">
			<div className="wdg-bg--blue-gradient wdg-pt--lg wdg-pb--lg has-background ">
				<div className="search__form-wrap alignwide wdg-grid-mdGutter wdg-pt--sm wdg-pb--sm">
						<div className="wdg-col-4_md-5_xs-1">
								<p>{keyword ? 'Results for:' : ''}</p>
								<h3 className="">{keyword ? '"' + keyword + '"': 'Search By Keyword'}</h3>
						</div>
						<div className=" wdg-col-8_md-7_xs-1">
              <SearchBar keyword={ keyword } handleKeyword={ handleKeyword } />
						</div>
				</div>
			</div>
			<div className = "search__results-container">
				<div className="search__container alignwide wdg-grid-mdGutter wdg-pt--md wdg-pb--md">
						<div className="search__filter wdg-col-4_md-5_xs-1">
							<h2 className="naco--kicker">Filters</h2>
              				<Facets initalFacets={ initalFacets } meta={ meta } handleFacetData={ handleFacetData } />
						</div>
						<div className="search__results wdg-col-8_md-7_xs-1">
						{ data && meta ?
							<h2 className="search__limit naco--kicker">Displaying { data.length }{ dataState ? ' of ' + meta.totalResults : '' } results</h2> : null
						}
						{ data.map( result => (
							<article key={ result.key } dangerouslySetInnerHTML={{ __html: result.rendered }} />
						))}
						{ !dataState ? <p>Sorry, no posts matched your criteria.</p> : ''}

              <Pagination page={ page } meta={ meta } updatePage={ updatePage } />
						</div>
				</div>

			</div>
		</div>
	);
}

export default Search;
